import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shuffle',
    pure: true,
})
export class ShufflePipe implements PipeTransform {

    transform<T>(items: undefined | null | T[], enabled = true): T[] {
        if (!items || items.length === 0)
            return [];
        if (!enabled)
            return items;
        return this.shuffle(items);
    }
    
    private shuffle<T>(items: T[]): T[] {
        for (let i = items.length - 1; i > 0; --i) {
            const j = Math.floor(Math.random() * (i + 1));
            [items[i], items[j]] = [items[j], items[i]];
        }
        return items;
    }

}
